import { Flex } from "antd";
import Search from "antd/es/input/Search";
import debounce from "lodash/debounce";
import { FC, useEffect, useMemo, useState } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

interface PointsSearchInputProps {
    fetchPoints: (query: string) => void;
    loading: boolean;
}

export const PointsSearchInput: FC<PointsSearchInputProps> = ({
    fetchPoints,
    loading,
}) => {
    const [searchValue, setSearchValue] = useState("");

    const debouncedSearch = useMemo(() => {
        const fn = debounce(async (value: string) => {
            if (value.length > 0 && value.length < 4) return;

            fetchPoints(value);
        }, 500);

        return fn;
    }, [fetchPoints]);

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    return (
        <Flex vertical gap={4}>
            <Search
                placeholder="Введіть назву або адресу магазину"
                allowClear
                size="large"
                onChange={(e) => {
                    const value = e.target.value;

                    setSearchValue(value);

                    debouncedSearch(value);
                }}
                loading={loading}
            />

            {searchValue.length > 0 && searchValue.length < 4 && (
                <PrimaryText textColor="error">
                    Мінімум 4 символи для пошуку
                </PrimaryText>
            )}
        </Flex>
    );
};
